import ReferencesFormModule from './containers/referencesFormModule'

export {default as ReferencesFormModuleLayout} from './components/referencesFormModuleLayout'

export default ReferencesFormModule
